import { ALL, COMPLETED, INCOMPLETE } from '@/model/trendradar/participants'

export default {
    title: 'Enter message',
    message: {
        label: 'Your message',
        required: 'Please enter your message'
    },
    recipients: {
        label: 'Select recipient',
        required: 'Please select an option'
    },
    options: {
        [ALL]: 'All participants',
        [COMPLETED]: 'Participants with complete evaluations',
        [INCOMPLETE]: 'Participants with incomplete or no evaluations'
    },
    success: 'The message was sent successfully',
    submit: 'Send'
}
